import { render } from "./TiresTypeForm.vue?vue&type=template&id=1b070812"
import script from "./TiresTypeForm.vue?vue&type=script&lang=js"
export * from "./TiresTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__